import { cloneElement } from 'react';
import { useContextMenu } from 'contexts/ContextMenuProvider';

/*
 * ActionButton component is used to render an action button in the context menu.
 * It checks if there is an actionButton set in the context and renders it.
 * If no actionButton is set, it will render the children passed to it.
 */
const ActionButton = ({ children = null }) => {
  const { actionButton } = useContextMenu();

  if (!actionButton && !children) return null;

  return cloneElement(actionButton || children);
};

export default ActionButton;
